var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelectIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "red",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0zm0 1.176c-4.873 0-8.824 3.95-8.824 8.824 0 4.873 3.95 8.824 8.824 8.824 4.873 0 8.824-3.95 8.824-8.824 0-4.873-3.95-8.824-8.824-8.824zm5.528 5.018c.297.283.323.77.06 1.087l-5.744 6.922c-.141.17-.338.259-.537.259-.157 0-.315-.056-.448-.169l-3.59-3.077c-.31-.265-.36-.749-.112-1.08.248-.333.7-.386 1.01-.121l3.057 2.62 5.29-6.377c.263-.317.718-.346 1.014-.064z",
    transform: "translate(-1366 -1288) translate(1137 1187) translate(10 87) translate(219 14)"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectIcon);
export default __webpack_public_path__ + "static/media/select-icon.b717ccbc.svg";
export { ForwardRef as ReactComponent };